var _filter, _filter2, _marker, _marker2, _rect, _circle, _circle2, _text, _text2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _path, _text3, _g9, _g10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg06StunServer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 900 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "stunGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#8b5cf6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#7c3aed"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "peerGradStun",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b82f6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2563eb"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "successGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#10b981"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#059669"
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glowPurple",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "shadowStun",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 4,
    stdDeviation: 10,
    floodOpacity: 0.3
  }))), _marker || (_marker = /*#__PURE__*/React.createElement("marker", {
    id: "arrowPurple",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#a78bfa"
  }))), _marker2 || (_marker2 = /*#__PURE__*/React.createElement("marker", {
    id: "arrowGreen",
    markerWidth: 10,
    markerHeight: 7,
    refX: 9,
    refY: 3.5,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3.5, 0 7",
    fill: "#34d399"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 900,
    height: 500,
    fill: "#0f172a"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 200,
    r: 180,
    fill: "none",
    stroke: "#1e293b",
    strokeWidth: 1,
    strokeDasharray: "4,4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 200,
    r: 220,
    fill: "none",
    stroke: "#1e293b",
    strokeWidth: 1,
    strokeDasharray: "4,4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 40,
    textAnchor: "middle",
    fill: "#f8fafc",
    fontFamily: "system-ui, sans-serif",
    fontSize: 24,
    fontWeight: "bold"
  }, "\n    STUN Server - Discovering Public IP\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 65,
    textAnchor: "middle",
    fill: "#a78bfa",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14
  }, "\n    Session Traversal Utilities for NAT\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 140)",
    filter: "url(#shadowStun)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 55,
    fill: "url(#stunGrad)",
    filter: "url(#glowPurple)"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 55,
    fill: "none",
    stroke: "#c4b5fd",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "55;60;55",
    dur: "2s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0.5;1",
    dur: "2s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("text", {
    y: -10,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: "bold"
  }, "STUN"), /*#__PURE__*/React.createElement("text", {
    y: 8,
    textAnchor: "middle",
    fill: "#e9d5ff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "Server"), /*#__PURE__*/React.createElement("text", {
    y: 28,
    textAnchor: "middle",
    fill: "#c4b5fd",
    fontFamily: "monospace",
    fontSize: 9
  }, "stun.google.com"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150, 300)",
    filter: "url(#shadowStun)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 140,
    height: 100,
    rx: 16,
    fill: "url(#peerGradStun)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "Peer A"), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 10
  }, "Private: 192.168.1.5"), /*#__PURE__*/React.createElement("text", {
    y: 22,
    textAnchor: "middle",
    fill: "#bfdbfe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "Behind NAT"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(750, 300)",
    filter: "url(#shadowStun)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -70,
    y: -50,
    width: 140,
    height: 100,
    rx: 16,
    fill: "url(#peerGradStun)"
  }), /*#__PURE__*/React.createElement("text", {
    y: -15,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 16,
    fontWeight: "bold"
  }, "Peer B"), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#93c5fd",
    fontFamily: "monospace",
    fontSize: 10
  }, "Private: 192.168.2.10"), /*#__PURE__*/React.createElement("text", {
    y: 22,
    textAnchor: "middle",
    fill: "#bfdbfe",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10
  }, "Behind NAT"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 190 250 Q 280 180 390 150",
    stroke: "#a78bfa",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowPurple)",
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(260, 190)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -12,
    width: 70,
    height: 24,
    rx: 12,
    fill: "#7c3aed"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, "\u2460 Request")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 410 180 Q 320 230 210 260",
    stroke: "#34d399",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowGreen)",
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(320, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -12,
    width: 120,
    height: 24,
    rx: 12,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 600
  }, "\u2461 203.0.113.10:5060")))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 710 250 Q 620 180 510 150",
    stroke: "#a78bfa",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowPurple)",
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(640, 190)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -35,
    y: -12,
    width: 70,
    height: 24,
    rx: 12,
    fill: "#7c3aed"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "system-ui, sans-serif",
    fontSize: 10,
    fontWeight: 600
  }, "\u2460 Request")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 490 180 Q 580 230 690 260",
    stroke: "#34d399",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrowGreen)",
    strokeDasharray: "8,4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-24",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0.5s"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(580, 250)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -60,
    y: -12,
    width: 120,
    height: 24,
    rx: 12,
    fill: "#059669"
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#fff",
    fontFamily: "monospace",
    fontSize: 9,
    fontWeight: 600
  }, "\u2461 198.51.100.20:8080")))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 400)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -180,
    y: -25,
    width: 360,
    height: 50,
    rx: 25,
    fill: "#022c22",
    stroke: "#34d399",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    y: 5,
    textAnchor: "middle",
    fill: "#6ee7b7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 14,
    fontWeight: 600
  }, "\n      \u2713 Now both peers know their public IP:Port!\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 220 320 L 680 320",
    stroke: "#22c55e",
    strokeWidth: 4,
    strokeDasharray: "15,8",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    values: "0;-46",
    dur: "2s",
    repeatCount: "indefinite"
  }))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 450,
    y: 340,
    textAnchor: "middle",
    fill: "#4ade80",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12,
    fontWeight: 600
  }, "\n    Can establish P2P connection \u2192\n  ")), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(50, 430)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 60,
    rx: 10,
    fill: "#1e1b4b",
    stroke: "#6366f1",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 25,
    fill: "#c4b5fd",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#a78bfa",
    fontWeight: "bold"
  }, "STUN is lightweight"), " \u2014 only used for\n    "), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 45,
    fill: "#94a3b8",
    fontFamily: "system-ui, sans-serif",
    fontSize: 11
  }, "\n      discovering public IP, not relaying data\n    "))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(510, 430)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 60,
    rx: 10,
    fill: "#022c22",
    stroke: "#10b981",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 25,
    fill: "#6ee7b7",
    fontFamily: "system-ui, sans-serif",
    fontSize: 12
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#34d399",
    fontWeight: "bold"
  }, "Free STUN servers:")), /*#__PURE__*/React.createElement("text", {
    x: 15,
    y: 45,
    fill: "#94a3b8",
    fontFamily: "monospace",
    fontSize: 11
  }, "\n      stun.l.google.com:19302\n    "))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg06StunServer);
export default __webpack_public_path__ + "static/media/06-stun-server.1f4da24708e6d0f953d7e5bb308b88e5.svg";
export { ForwardRef as ReactComponent };